import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import FormErrors from 'src/view/shared/form/formErrors';
import { v4 as uuid } from 'uuid';
import classNames from 'src/modules/shared/classNames';

export function InputFormItem(props) {
  const [inputId] = useState(uuid());

  const {
    label,
    name,
    hint,
    type,
    placeholder,
    autoFocus,
    autoComplete,
    required,
    externalErrorMessage,
    disabled,
    endAdornment,
    ignoredErrorTypes,
    hasDarkBackground,
    readOnly,
    noMessageError = false
  } = props;

  const {
    register,
    errors,
    formState: { touched, isSubmitted },
  } = useFormContext();

  const errorMessage = FormErrors.errorMessage(
    name,
    errors,
    touched,
    isSubmitted,
    externalErrorMessage,
    ignoredErrorTypes,
  );

  return (
    <div>
      <style>
        {`
          input::placeholder {
            color: rgba(255, 255, 255, 0.6) !important;
          }
        `}
      </style>
      <div>
        {Boolean(label) && (
          <label
            className={`block font-jakartaMedium font-medium text-base mb-1.5`}
            htmlFor={inputId}
          >
            {label}{' '}
            {required ? (
              <span className="text-sm text-red-400">
                *
              </span>
            ) : null}
          </label>
        )}

        <div className="flex flex-nowrap items-baseline ">
          <div className="relative w-full">
            <input
              id={inputId}
              name={name}
              type={type}
              ref={register}
              onChange={(event) => {
                props.onChange &&
                  props.onChange(event.target.value);
              }}
              onBlur={(event) => {
                props.onBlur && props.onBlur(event);
              }}
              placeholder={placeholder || undefined}
              autoFocus={autoFocus || undefined}
              autoComplete={autoComplete || undefined}
              disabled={disabled}
              readOnly={readOnly}
              className={classNames( 'h-[50px] bg-white/30 text-white/60  border-none focus:ring-none ', 
                hasDarkBackground
                  ? 'border-transparent focus:border-transparent focus:ring-none '
                  : ' bg-white ',
                `block w-full text-sm rounded-lg border-transparent px-2 py-4  ${
                  errorMessage
                    ? ' text-red-600 pr-8'
                    : ''
                }  hover:ring-none`,
              )}
              style={{
                boxShadow: 'none',
              }}
            />
            {errorMessage && (
              <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#E88697] text-lg">
                *
              </span>
            )}
          </div>
          {endAdornment && (
            <span className="ml-2 ">
              {endAdornment}
            </span>
          )}
        </div>
      </div>
      {errorMessage && !noMessageError && <div className="mt-2 text-sm text-red-600">
        {errorMessage}
      </div>}
      {Boolean(hint) && (
        <div className="mt-2 text-sm text-gray-500">
          {hint}
        </div>
      )}
    </div>
  );
}

InputFormItem.defaultProps = {
  type: 'text',
  required: false,
};

InputFormItem.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  hasDarkBackground: PropTypes.bool,
  type: PropTypes.string,
  label: PropTypes.string,
  hint: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  prefix: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  externalErrorMessage: PropTypes.string,
  endAdornment: PropTypes.any,
  onChange: PropTypes.any,
  ignoredErrorTypes: PropTypes.array,
  noMessageError: PropTypes.bool,
};

export default InputFormItem;
